import { render, staticRenderFns } from "./modal-new.vue?vue&type=template&id=ac645438&scoped=true"
import script from "./modal-new.vue?vue&type=script&lang=js"
export * from "./modal-new.vue?vue&type=script&lang=js"
import style0 from "./modal-new.vue?vue&type=style&index=0&id=ac645438&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac645438",
  null
  
)

export default component.exports